import { DeviceVariantsEnum, RadioRolesEnum } from '@ubnt/link-core/enums';
import Device from '@ubnt/link-core/modules/devices/Device';
import { orderBy, uniqBy, first } from 'lodash-es';
import {
  bandSupportsChannel,
  getBandByVariant,
  is5GHzBandByVariant,
} from '@ubnt/wifi-calculator/utils/regulatoryLimits';
import { getBaseBandByVariant } from '@ubnt/wifi-calculator/utils/getBaseBandByVariant';
import { isProduction } from 'utils/env';
import type { ApStateDevice, ClientStateDevice, StateDevice } from './slice';

export const throwReducerError = (message: string) => {
  if (!isProduction) {
    throw Error(message);
  }
};

export const getMloVariants = (
  mloVariants: ValuesOf<typeof DeviceVariantsEnum>[] | undefined,
  activeVariant?: ValuesOf<typeof DeviceVariantsEnum>
) => uniqBy(orderBy(mloVariants, [(variant) => variant === activeVariant], ['desc']), getBaseBandByVariant);

export const get5GhzVariants = (variants: ValuesOf<typeof DeviceVariantsEnum>[]) => {
  return variants.filter(is5GHzBandByVariant);
};

export const getMeshVariant = (variants: ValuesOf<typeof DeviceVariantsEnum>[], channel?: number) => {
  const fiveGhzVariants = get5GhzVariants(variants);
  if (fiveGhzVariants.length === 1 || channel === undefined) {
    return first(fiveGhzVariants);
  }

  return fiveGhzVariants.find((variant) => bandSupportsChannel(getBandByVariant(variant), channel));
};

export const isRoleAp = (role: ValuesOf<typeof RadioRolesEnum> | null) => role === RadioRolesEnum.Ap;
export const isAp = (device: StateDevice): device is ApStateDevice => device.role === RadioRolesEnum.Ap;
export const isClient = (device: StateDevice): device is ClientStateDevice => device.role === RadioRolesEnum.Cpe;

export const isAfcForcedGetter = (device: Device) => device.supportsAfc && device.supportsOutdoorMode;
